import { Link } from "react-router";
import { useTranslation } from "react-i18next";

export function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="container">
      <div className="surface" style={{ textAlign: "center", maxWidth: "32rem", margin: "0 auto" }}>
        <h1>{t("notFound.title")}</h1>
        <p>{t("notFound.body")}</p>
        <Link to="/" className="btn btn-primary">{t("notFound.back")}</Link>
      </div>
    </div>
  );
}
